import { BodyM, BodyMBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';

interface IAmountCellProps {
	amount: number | string;
	date: string;
}

const AmountCell = ({ amount, date }: IAmountCellProps) => {
	return (
		<div>
			<div>
				<BodyMBold inline>{String(amount)}</BodyMBold>
				<BodyM inline>{translate('OMR')}</BodyM>
			</div>
			<div>
				<BodyM color="disabled-light" disableMargin>
					{date}
				</BodyM>
			</div>
		</div>
	);
};

export default AmountCell;
